import React, { Component } from "react";
import { Navigate, Link } from "react-router-dom";

import withRouter from "./functions/withRouter";
import { getFavoriteBook, getBook } from "./functions/books";
import { existingOpenTrade } from "./functions/trade";

import Authenticated from "./Authenticated";
import TradeProcess from "./TradeProcess";
import Loading from "./Loading";

class TradeProcessWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      givingBook: getFavoriteBook(),
      receivingBook: null,
      existingTrade: null
    }
  }

  componentDidMount() {
    getBook(this.props.params.bookID).then((book) => {
      this.setState({receivingBook: book})
    });
  }

  setUser(user) {
    this.setState({user})
  }

  async checkExistingTrade(user) {
    this.setState({existingTrade: (await existingOpenTrade(user))});
  }

  render() {
    if (!this.state.givingBook) {
      return (<Navigate to="/" replace={true} />);

    } else if (!this.state.receivingBook) {
      return (<Loading />);

    } else {
      return (
        <Authenticated required={true} render={(user) => {
            if (this.state.existingTrade === null) {
              this.checkExistingTrade(user);
              return <Loading />;

            } else if (this.state.existingTrade === true) {
              return (<div className="Content">
                        <p className="TextBold TextCenter">Error</p>
                        <p className="TextCenter">You already have a trade in progress! Once you’ve sent and received your book, you can start a new one.
                          You can also cancel your open trade if you haven't sent your book yet.</p>
                        <p className="TextCenter"><Link to="/"><span className="Button Margin">Go Back</span></Link></p></div>
              );

            } else if (this.state.existingTrade === false) {
              return <TradeProcess
                user={user}
                givingBook={this.state.givingBook}
                receivingBook={this.state.receivingBook}
                method={this.props.method}
              />;
            }
        }} />
      );
    }
  }
}

export default withRouter(TradeProcessWrapper);
